import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import { ACCOMMODATED_STUDENTS, DormitoryServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListAccommodatedStudents from "./List";

export const resources = {
  isMenu: true,
  icon: <MeetingRoomIcon />,
  name: DormitoryServicePath + ACCOMMODATED_STUDENTS,
  title: "Настанени студенти",
  list: <ListAccommodatedStudents />,
  permission: permissions.canPreviewDormitoryAccommodations,
};
